// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"126244f4","112":"a8b833f4","348":"f9e98566","426":"9a9d0ddc","453":"65d48ee3","911":"41f3958c"}[chunkId] + ".chunk.js";
};